import { gql, useQuery } from '@apollo/client';
import { ActivityDestinationViewSearchDocument, ActivityDestinationViewSearch } from 'src/common/__generated__/api';
import ActivitySearch = ActivityDestinationViewSearch.ActivitySearch;

const activitySearchSearch = gql`
  ${ActivityDestinationViewSearchDocument}
`;

export type activityResponse = { activitySearch: ActivitySearch };

export function useActivitySearchQuery(variables: ActivityDestinationViewSearch.Variables) {
  const response = useQuery<activityResponse>(activitySearchSearch, {
    variables,
    ssr: false,
    fetchPolicy: 'no-cache'
  });
  return { ...response };
}

export default useActivitySearchQuery;
